export enum SetupCoverTypeEnum {
  AtHome = 'cover_at_home.png',
  AutomationSetup = 'cover_automation.png',
  SanitaryInstallationSetup = 'cover_sanitary_installation.png',
  HeatingInstallationSetup = 'cover_heating_installation.png',
  ResourceSetup = 'cover_resource.png',
  ReguardSetup = 'cover_reguard.png',
}
